import { Box, Button, Checkbox, FormControl, FormControlLabel, Grid, InputAdornment, InputLabel, MenuItem, Paper, Select, Stack, TextField, Tooltip, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { Colors } from '../../../Styles/Colors'
import { DataGrid } from '@mui/x-data-grid'
import CommonGridHeader, { CommonEditButton } from '../../../Components/Common Components/CommonComponents'
import CommonValidation from '../../../Components/CommonFunctions/CommonValidation'
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { CheckAccessFunc, formatDate } from '../../../Components/CommonFunctions/CommonFunctions'
import ToastMsg from '../../../Components/ToastMsg/ToastMsg'
import RestAPIService from '../../../Utility/Services/RestAPIService'
import { Serviceurls } from '../../../Utility/API/Serviceurls'
import moment from 'moment'


export default function ClinicalStaff() {
  const [tblItem, settblItem] = useState({
    stafList: [],
    tblLoader: false,
    page: 0,
    rowsPerPage: 10,
  })
  const [stafValues, setstafValues] = useState({
    name: '',
    qualification: '',
    reg_no: '',
    emp_no: '',
    dob: null,
    contact_no: '',
    role: '',
    verify_by: '',
    active: false,
    isEdit: false,
    editID: null
  })
  const [message, setMessage] = useState({
    isErrorMsgText: '',
    successMsgText: '',
    isErrorMsg: false,
    successMsg: false,
  })

  useEffect(() => {
    clinicalstaffGet()
  }, [])


  const clinicalstaffGet = () => {
    try {
      settblItem({ ...tblItem, tblLoader: true })
      RestAPIService.getAll(Serviceurls.JMO_CLINICAL_STAFF_GET)
        .then((response) => {
          if (response.data.status === 'success') {
            settblItem({
              ...tblItem,
              stafList: response.data.data || [],
              tblLoader: false,
            })
          }
        })
        .catch((e) => {
          settblItem({ ...tblItem, tblLoader: false })
          errorMessage(e.response.data.message || e.message);
        })
    } catch (e) {
      errorMessage(e.message)
    }
  }
  const clinicalstaffPost = () => {
    try {
      settblItem({ ...tblItem, tblLoader: true })
      let data = {
        "name": stafValues.name || '',
        "qualification": stafValues.qualification || '',
        "registration_number": stafValues.reg_no || null,
        "employee_number": stafValues.emp_no || null,
        "date_of_birth": stafValues.dob ? stafValues.dob.format('YYYY-MM-DD') : null,
        "contact_number": stafValues.contact_no || null,
        "role": stafValues.role || '',
        "verified_by": stafValues.verify_by || '',
        "is_active": stafValues.active ? true : false
      }
      settblItem({ ...tblItem, tblLoader: true })
      RestAPIService.create(data, Serviceurls.JMO_CLINICAL_STAFF_GET)
        .then((response) => {
          if (response.data.status === 'success') {
            successMessage(response.data.message)
            settblItem({ ...tblItem, tblLoader: false })
            handleClear()
            clinicalstaffGet()
          }
        })
        .catch((e) => {
          settblItem({ ...tblItem, tblLoader: false })
          errorMessage(e.response.data.message || e.message);
        })
    } catch (e) {
      errorMessage(e.message)
    }
  }

  const clinicalstaffPut = () => {
    try {
      settblItem({ ...tblItem, tblLoader: true })
      console.log(stafValues, 'stafValues.dob')
      let formatDate = (dob) => {
        if (!dob) return null;
        const date = new Date(dob);
        if (isNaN(date.getTime())) return null; // invalid date

        // Format to YYYY-MM-DD
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Month is 0-indexed
        const day = String(date.getDate()).padStart(2, '0');

        return `${year}-${month}-${day}`;
      };
      let data = {
        "name": stafValues.name || '',
        "qualification": stafValues.qualification || '',
        "registration_number": stafValues.reg_no || null,
        "employee_number": stafValues.emp_no || null,
        "date_of_birth": stafValues.dob ? moment(stafValues.dob).format('YYYY-MM-DD') : null,
        "contact_number": stafValues.contact_no || null,
        "role": stafValues.role || '',
        "verified_by": stafValues.verify_by || '',
        "is_active": stafValues.active ? true : false
      }
      settblItem({ ...tblItem, tblLoader: true })
      RestAPIService.update(stafValues.editID, data, Serviceurls.JMO_CLINICAL_STAFF_GET)
        .then((response) => {
          if (response.data.status === 'success') {
            successMessage(response.data.message)
            settblItem({ ...tblItem, tblLoader: false })
            handleClear()
            clinicalstaffGet()
          }
        })
        .catch((e) => {
          settblItem({ ...tblItem, tblLoader: false })
          errorMessage(e.response.data.message || e.message);
        })
    } catch (e) {
      errorMessage(e.message)
    }
  }

  const renderTextBox = (label, statekey, value, width) => {
    let role_list = [
      { label: "JMO", value: "JMO" },
      { label: "Physician Assistant", value: "PHYSICIAN_ASSISTANT" },
      { label: "Medical Assistant", value: "MEDICAL_ASSISTANT" },
      { label: "Doctor's Assistant", value: "DOCTORS_ASSISTANT" },
    ];
    return (
      <Box id="eMed_srvConfig_divs">
        {
          statekey === "role" ?
            <FormControl sx={{ width: "15vw" }} size="small">
              <InputLabel>{label + " *"}</InputLabel>
              <Select
                value={value ? value : ""}
                name={statekey}
                label={label + " *"}
                // disabled={this.state.isEdit ? true : false}
                onChange={(event) => {
                  setstafValues({ ...stafValues, [statekey]: event.target.value })
                }}
              >
                {
                  role_list.map((list, index) => (
                    <MenuItem key={index} value={list.value} >{list.label}</MenuItem>
                  ))
                }
              </Select>
            </FormControl>
            : statekey === 'dob' ?
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  value={stafValues.dob || null}
                  inputFormat='DD-MM-YYYY'
                  label={label + "*"}
                  // disabled={this.props.OTHome ? false : this.state.isDisable}
                  onChange={
                    (newDate) => {
                      setstafValues({ ...stafValues, dob: newDate })
                    }}
                  renderInput={(params) => <TextField size='small' sx={{ width: '15vw' }} {...params} />}
                />
              </LocalizationProvider>
              :
              <TextField
                sx={{ width: "15vw" }}
                autoComplete="off"
                required={statekey !== "reg_no" && statekey !== "emp_no" ? true : false}
                // disabled={(this.state.isEdit && this.state.selectedItem?.status === "Approved" && label != "Qualification" && label != "Commission" || (this.state.isEdit && this.state.selectedItem?.status !== "Approved")) ? true : false}
                size="small"
                label={label}
                name={statekey}
                value={value ? value : ""}
                onChange={(e) => { handleChange(e) }}
              />
        }
      </Box>
    )
  }

  const handleChange = (event) => {
    const name = event.target.name;
    const value = event.target.value.trimStart();
    let isValid = false;

    let updatedValues = { ...stafValues };

    switch (name) {
      case "reg_no":
      case "emp_no":
        isValid = CommonValidation.alphanumValidation(value);
        if (value === "" || (isValid && value.length <= 50)) {
          updatedValues[name] = value;
          setstafValues(updatedValues);
        }
        return;
      case "contact_no":
        isValid = CommonValidation.numberOnly(value);
        if (value === "" || (isValid && value.length <= 12)) {
          updatedValues[name] = value;
          setstafValues(updatedValues);
        }
        return;
      case "name":
        isValid = CommonValidation.alphabetOnly(value);
        if (value === "" || (isValid && value.length <= 50)) {
          updatedValues[name] = value;
          setstafValues(updatedValues);
        }
        return;
      case "qualification":
        updatedValues[name] = value;
        setstafValues(updatedValues);
        return;
      default:
        isValid = CommonValidation.alphabetOnly(value);
        if (value === "" || isValid) {
          let updatedSelectedItem = { ...stafValues, [name]: value };
          setstafValues(updatedSelectedItem);  // assuming you use setSelectedItem
        }
        return;
    }
  };

  tblItem.stafList?.forEach((element, index) => element.sno = index + 1)
  const columns = [
    { field: 'sno', headerName: 'S.No', sortable: false, flex: 0.06, },
    {
      field: 'name', headerName: 'Name', flex: 0.18, type: 'string',
      renderCell: (cellvalues) => {
        return (
          <Box>{cellvalues?.row?.name?.length > 15 ?
            <Tooltip placement="top" title={cellvalues?.row?.name} arrow>
              <Typography fontSize={'.9vw'}>{cellvalues?.row?.name.slice(0, 10) + "..."}</Typography>
            </Tooltip> : <Typography fontSize={'.9vw'}>{cellvalues?.row?.name || '-'}</Typography>}
          </Box>
        )
      }
    },
    {
      field: 'qualification', headerName: 'Qualification', flex: 0.18, type: 'string',
      renderCell: (cellvalues) => {
        return (
          <Box>{cellvalues?.row?.qualification?.length > 15 ?
            <Tooltip placement="top" title={cellvalues?.row?.qualification} arrow>
              <Typography fontSize={'.9vw'}>{cellvalues?.row?.qualification.slice(0, 10) + "..."}</Typography>
            </Tooltip> : <Typography fontSize={'.9vw'}>{cellvalues?.row?.qualification || '-'}</Typography>}
          </Box>
        )
      }
    },
    {
      field: 'registration_number', headerName: 'Register No', flex: 0.18, type: 'string',
      renderCell: (cellvalues) => {
        return (
          <Box>{cellvalues?.row?.registration_number?.length > 15 ?
            <Tooltip placement="top" title={cellvalues?.row?.registration_number} arrow>
              <Typography fontSize={'.9vw'}>{cellvalues?.row?.registration_number.slice(0, 10) + "..."}</Typography>
            </Tooltip> : <Typography fontSize={'.9vw'}>{cellvalues?.row?.registration_number || '-'}</Typography>}
          </Box>
        )
      }
    },
    {
      field: 'employee_number', headerName: 'Employee No', flex: 0.18, type: 'string',
      renderCell: (cellvalues) => {
        return (
          <Box>{cellvalues?.row?.employee_number?.length > 15 ?
            <Tooltip placement="top" title={cellvalues?.row?.employee_number} arrow>
              <Typography fontSize={'.9vw'}>{cellvalues?.row?.employee_number.slice(0, 10) + "..."}</Typography>
            </Tooltip> : <Typography fontSize={'.9vw'}>{cellvalues?.row?.employee_number || '-'}</Typography>}
          </Box>
        )
      }
    },
    {
      field: 'date_of_birth', headerName: 'DOB', flex: 0.18, headerAlign: 'center', align: 'center',
      renderCell: (cellvalues) => {
        return (
          <Box>
            <Typography fontSize={'.9vw'}>{formatDate(cellvalues?.row?.date_of_birth) || '-'}</Typography>
          </Box>
        )
      }
    },
    {
      field: 'contact_number', headerName: 'Contact No', flex: 0.18, type: 'number',
      renderCell: (cellvalues) => {
        return (
          <Box>{cellvalues?.row?.contact_number?.length > 15 ?
            <Tooltip placement="top" title={cellvalues?.row?.contact_number} arrow>
              <Typography fontSize={'.9vw'}>{cellvalues?.row?.contact_number.slice(0, 10) + "..."}</Typography>
            </Tooltip> : <Typography fontSize={'.9vw'}>{cellvalues?.row?.contact_number || '-'}</Typography>}
          </Box>
        )
      }
    },
    {
      field: 'action', headerName: 'Action', flex: 0.18, headerAlign: 'center', align: 'center',
      renderCell: (cellvalues) => {
        return (
          <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={1}>
            <CommonEditButton
              // disable={!CheckAccessFunc("front_office", "Settings", "Hospital Configuration", "Doctor List", "SubTab")?.editAccess} 
              size="1.5vw"
              onClick={() => {
                setstafValues({
                  name: cellvalues?.row?.name || '',
                  qualification: cellvalues?.row?.qualification || '',
                  reg_no: cellvalues?.row?.registration_number || '',
                  emp_no: cellvalues?.row?.employee_number || '',
                  dob: cellvalues?.row?.date_of_birth || null,
                  contact_no: cellvalues?.row?.contact_number || '',
                  role: cellvalues?.row?.role || '',
                  verify_by: cellvalues?.row?.verified_by || '',
                  active: cellvalues?.row?.is_active,
                  isEdit: true,
                  editID: cellvalues?.row?.id || null,
                })
              }}
            />
          </Stack>
        )
      }
    },
  ]
  const handleClear = () => {
    setstafValues({
      name: '',
      qualification: '',
      reg_no: '',
      emp_no: '',
      dob: null,
      contact_no: '',
      role: '',
      verify_by: '',
      active: false,
      isEdit: false,
      editID: null,
    })
  }

  const errorMessage = (message) => {
    setMessage({
      ...message,
      isErrorMsg: true,
      isErrorMsgText: message,
    })
  }

  const successMessage = (message) => {
    setMessage({
      ...message,
      successMsg: true,
      successMsgText: message,
    })
  }
  const msgClose = () => {
    setMessage({
      ...message,
      isErrorMsg: false,
      isErro0rMsgText: '',
      successMsg: false,
      successMsgText: ''
    })
  }
  const validationCheck = () => {
    if (!stafValues.name) {
      errorMessage("Please Enter Name")
      return;
    } else if (!stafValues.qualification) {
      errorMessage("Please Enter Qualification")
      return;
    } else if (!stafValues.dob) {
      errorMessage("Please Enter Date of Birth")
      return;
    } else if (!stafValues.contact_no) {
      errorMessage("Please Enter Contact Number")
      return;
    } else if (!stafValues.role) {
      errorMessage("Please Select Role")
      return;
    } else if (!stafValues.verify_by) {
      errorMessage("Please Enter Verified By")
      return;
    } else {
      if (stafValues.isEdit) {
        clinicalstaffPut()
      } else {
        clinicalstaffPost()
      }
    }
  }
  // render
  return (
    <Box id="eMed_srvConfig_Container" sx={{ backgroundColor: Colors.configHomeBg }}>
      <Grid container spacing={3} className="eMed_srvConfig_Box">
        <Grid item xs={7.6}>
          <Paper className="eMed_srvConfig_Div" >
            <DataGrid
              rows={tblItem.stafList}
              columns={columns}
              getRowId={(row) => row.sno}
              localeText={{
                toolbarColumns: "",
                toolbarDensity: "",
                toolbarExport: "",
                toolbarFilters: "",
                toolbarExportPrint: ""
              }}
              disableSelectionOnClick
              components={{
                Toolbar: CommonGridHeader.CommonToolBar,
                NoRowsOverlay: () => {
                  return (
                    <Stack direction="row" justifyContent="center" alignItems="center" sx={{ height: "53vh" }}>
                      {"No Records to Be Shown"}
                    </Stack>
                  )
                }
              }}
              headerHeight={40}
              rowCount={tblItem.stafList.length}
              page={tblItem.page}
              onPageChange={(newPage) => settblItem({ ...tblItem, page: newPage })}
              pageSize={tblItem.rowsPerPage}
              onPageSizeChange={(newPageSize) => settblItem({ ...tblItem, rowsPerPage: newPageSize })}
              rowsPerPageOptions={[10, 20, 30]}
              pagination
              loading={tblItem.tblLoader}
            />
          </Paper>
        </Grid>
        <Grid item xs={4.4}>
          <Paper className="eMed_srvConfig_Div">
            <Box className='eMed_srvConfig_rightHead' style={{ backgroundColor: Colors.DataTblHeaderbg }}>
              <Typography sx={{ fontWeight: 600, marginLeft: '1.5vw', color: '#616161' }}>{"Clinical Staff Configuration"}</Typography>
            </Box>
            <Box className="eMed_srvConfig_subDiv">
              <Stack direction="row" justifyContent="space-between" alignItems="center">
                {renderTextBox('Name', "name", stafValues.name)}
                {renderTextBox('Qualification', "qualification", stafValues.qualification)}
              </Stack>
              <Stack direction="row" justifyContent="space-between" alignItems="center">
                {renderTextBox('Registration No', "reg_no", stafValues.reg_no)}
                {renderTextBox('Employee No', "emp_no", stafValues.emp_no)}
              </Stack>
              <Stack direction="row" justifyContent="space-between" alignItems="center">
                {renderTextBox('Date of Birth', "dob", stafValues.dob)}
                {renderTextBox('Contact No', "contact_no", stafValues.contact_no)}
              </Stack>
              <Stack direction="row" justifyContent="space-between" alignItems="center">
                {renderTextBox('Role', "role", stafValues.role)}
                {renderTextBox('Verified By', "verify_by", stafValues.verify_by)}
              </Stack>
              <Stack direction="row" justifyContent="space-between" alignItems="center">
                {<Box sx={{ width: "15vw" }}>
                  <FormControlLabel label="Active" labelPlacement="start" sx={{ gap: '1vw' }} control={<Checkbox checked={stafValues.active ? true : false} onChange={(e) => { setstafValues({ ...stafValues, active: e.target.checked }) }} />} />
                </Box>}
              </Stack>
            </Box>
            <Stack spacing={2} direction="row" id='eMed_srvConfig_rightBtnCon' sx={{ backgroundColor: Colors.DataTblHeaderbg }} alignItems="center" justifyContent="center">
              <Button variant='outlined' emed_tid="doctor_config_clear_btn" size="small" id="eMed_Config_btn" onClick={() => { handleClear() }}>{"Clear"}</Button>
              <Button variant='contained' emed_tid="doctor_config_save_btn"
                disabled={!CheckAccessFunc("front_office", "Settings", "Hospital Configuration", "Clinical Staff", "SubTab")?.editAccess || tblItem.tblLoader}
                size="small" id="eMed_Config_btn" onClick={() => { validationCheck() }}>{"Save"}</Button>
            </Stack>
          </Paper>
        </Grid>
      </Grid>
      {message.isErrorMsg ?
        <ToastMsg
          severity={'error'}
          msg={message.isErrorMsgText}
          msgPop={msgClose}
        />
        : null}
      {message.successMsg ?
        <ToastMsg
          severity={'success'}
          msg={message.successMsgText}
          msgPop={msgClose}
        />
        : null}
    </Box>
  )
}
